import React, { useState } from 'react';
import LateralMenuContent from '../LateralMenuContent';
import AlunoTurmaForm from '../../../../components/AlunoTurma/AlunoTurmaForm';
import { useLocation } from 'react-router';

export default function AlunoTurmaFormMenu() {
    let alunoTurmaProp = {};
    const location = useLocation();
    if (location.state) {
        alunoTurmaProp = location.state.alunoTurma;
    }
    const [alunoTurma] = useState(alunoTurmaProp);
    return (
        <LateralMenuContent child={AlunoTurmaForm} alunoTurmaProp={alunoTurma} />
    );
}